export default __webpack_public_path__ + "static/media/testimonio.41a60d9c.jpg";